import { UseMutationOptions } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { AppGameEventResponse } from '@playq/octopus2-liveops';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

import { gameEventRetrieveBatchQueryKey } from './constants';
import { IRetrieveGameEventsBatchParams } from './types';

export const useGameEventsBatchRetrieve = (
  options?: UseMutationOptions<AppGameEventResponse[], GenericFailure | Error, IRetrieveGameEventsBatchParams>
) =>
  useEitherMutation(({ ids, ignoreMissed = true }) => services2.appGameEventsService.retrieveBatch(ids, ignoreMissed), {
    mutationKey: gameEventRetrieveBatchQueryKey,
    ...options,
  });
